export const API_BASE_URI = process.env.REACT_APP_API_BASE_URL;

export const growthbookApiKey = 'sdk-m7iU6vjgsjwmfI89';
export const devMode = false;
